export default {
  methods: {
    registerEventBusEvents() {
      this.$eventBus.$on('trigger-change-step', (data) => {
        this.triggerChangeStep(data)
      })

      this.$eventBus.$on('survey-answer', (data) => {
        this.triggerFeedback(data)
      })

      this.$eventBus.$on('rank-answer', (data) => {
        this.triggerFeedback(data)
      })

      this.$eventBus.$on('field-answer', (data) => {
        this.triggerFeedback(data)
      })

      this.$eventBus.$on('checkbox-answer', (data) => {
        this.triggerFeedback(data)
      })

      this.$eventBus.$on('close', (data) => {
        this.triggerCloseWidget()
      })
    },
    async triggerChangeStep(val) {
      this.$v.$touch()

      // Wait for the validation to complete
      await this.waitForValidation(this.$v);

      if (this.$v.$invalid) {
        return
      }

      if (val === 'next' || val === 'prev') {
        // Check if next step exists
        const num = (val === 'next' ? 1 : -1)
        const nextStep = this.widget.steps[this.targetStepIndex + num]

        if (nextStep) {
          if (process.env.PROJECT === 'scriptGenerator') {
            this.setTargetStep(this.targetStepIndex + num)
          } else {
            this.setTargetStep(nextStep.id)
          }
        }
      } else {
        this.widget.steps.forEach((step, index) => {
          if (step.id === val) {
            if (process.env.PROJECT === 'scriptGenerator') {
              this.setTargetStep(index)
            } else {
              this.setTargetStep(val)
            }
          }
        })
      }
    },
    waitForValidation(validation) {
      return new Promise((resolve) => {
        if (!validation.$pending) {
          resolve()
          return
        }
        const unwatch = this.$watch(
          () => validation.$pending,
          (pending) => {
            if (!pending) {
              unwatch()
              resolve()
            }
          },
        )
      })
    },
    // closeButtonBgColor() {
    //   // ToDo Figure out why this no work
    //   if (this.widget.styling.borderRadius !== 0) {
    //     return this.getColorBrightness(this.widget.settings.closeButtonColor) > 50
    //       ? 'rgba(0,0,0,.3)'
    //       : 'rgba(255,255,255,.3)'
    //   } else {
    //     return 'transparent'
    //   }
    // },
    // getColorBrightness(value) {
    //   return colorBrightness(value)
    // },
  },
}
